"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAccountBusinessParsedResponse = void 0;
function transformAccountBusinessParsedResponse(business) {
    return {
        accountId: business.account_id,
        businessId: Number(business.account_business_id),
    };
}
exports.transformAccountBusinessParsedResponse = transformAccountBusinessParsedResponse;
//# sourceMappingURL=AccountBusiness.js.map